<div class="container" [class]="backgroundStyle" style="background: rgb(37, 45, 33) !important;
background: linear-gradient(90deg, rgb(84, 101, 74) 0%, rgba(62, 217, 167, 1) 98%, rgba(56, 68, 49, 1) 100%) !important;
" *ngIf="this.gradientConfig.layout === 'horizontal' && this.gradientConfig.subLayout === 'horizontal-2'; else mainHeader">
    <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
</div>
<ng-template #mainHeader [class]="backgroundStyle">
    <div class="m-header" [class]="backgroundStyle">
        <!-- <button (click)="toggleNavContent()">HELLO</button> -->
        <a *ngIf="isMobile" href="javascript:" class="mobile-menu" id="mobile-collapse" (click)="toggleNavContent()"><span></span></a>
        <!-- <a [routerLink]="['/dashboard/analytics']" class="b-brand"> -->
        <a href="/loading" class="b-brand">
            <!-- Below QUBES-OLD Logo -->
            <!-- <img id="main-logo" src="assets/images/logo-qubes.png" alt="" class="logo"> -->
            <!-- Below QUBES-NEW Logo -->
            <img *ngIf="this?.currentUser?.organisationId == 2" id="main-logo" src="assets/images/cammsLogoNew.png" alt="" class="logo" height="60">
            <img *ngIf="this?.currentUser?.organisationId != 2 && this?.userDetails?.userGroupName=='MOH Clinic' " id="main-logo" src="assets/images/qmsLogoClinicUser.png" alt="" class="logo" height="60">
            <!-- Below CAMMS Logo -->
            <!-- <img *ngIf="this.gradientConfig['layout'] === 'vertical'" id="main-logo" src="assets/images/CAMMS-logo-new.jpg" alt="" class="logo" height="60"> -->
            <span *ngIf="[ 'MOH State', 'MOH District', 'Call Center'].includes(this.userDetails?.userGroupName) && this?.currentUser?.organisationId != 2 " class="version-txt" style="color: white;margin-right:-80px;">Welcome to CAMMS<br>Quantum Medical Solutions Sdn Bhd</span>
            <img src="assets/images/logo-icon.png" alt="" class="logo-thumb">
        </a>
        <a class="mob-toggler" [ngClass]="{'on' : this.menuClass}" href="javascript:" (click)="toggleMobOption()"><i
                class="feather icon-more-vertical"></i></a>
    </div>
    <div class="collapse navbar-collapse" [style.display]="this.collapseStyle" [class]="backgroundStyle">
        <app-nav-left class="mr-auto"></app-nav-left>
        <app-nav-right class="ml-auto"></app-nav-right>
    </div>
</ng-template>